import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { COLORS } from "@/shared/constants/themes";
import { S } from "@/shared/constants/styles";
import { useIsMobile } from "@/shared/hooks/useMediaQuery";

export default function SpendingChart({ pieData }) {
  const mobile = useIsMobile();
  return (
    <div style={{ ...S.card, padding: mobile ? 16 : 22 }}>
      <div style={S.sectionTitle}>Spending by Category</div>
      {pieData.length > 0 ? (
        <ResponsiveContainer width="100%" height={mobile ? 200 : 240}>
          <PieChart>
            <Pie
              data={pieData}
              cx="50%"
              cy="50%"
              innerRadius={mobile ? 40 : 52}
              outerRadius={mobile ? 72 : 92}
              paddingAngle={3}
              dataKey="value"
            >
              {pieData.map((_, i) => (
                <Cell key={i} fill={COLORS[i % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip formatter={(v) => "$" + Number(v).toFixed(2)} />
            <Legend iconSize={8} wrapperStyle={{ fontSize: 11 }} />
          </PieChart>
        </ResponsiveContainer>
      ) : (
        <div
          style={{
            color: "#cbd5e1",
            textAlign: "center",
            padding: "60px 0",
            fontSize: 13,
          }}
        >
          No expenses this month
        </div>
      )}
    </div>
  );
}
